import api from './api';

// Feature keys for tracking
export const FEATURES = {
  TRAINING_IN_PROGRESS: 'training_in_progress',
  NUTRITION_TRACKER: 'nutrition_tracker',
  AI_PLANNER: 'ai_planner',
  WALKING: 'walking',
  STATISTICS: 'statistics',
  PHOTOS: 'photos',
  TIMER: 'timer',
  CALENDAR: 'calendar',
  GYM_FINDER: 'gym_finder',
  PLANNER: 'planner',
};

// Sub-features for Nutrition Tracker
export const NUTRITION_SUB_FEATURES = {
  DATABASE: 'database',
  FRESH_PRODUCE: 'fresh_produce',
  SCAN: 'scan',
  MY_SCANNED: 'my_scanned',
  MY_MEALS: 'my_meals',
  MY_PRODUCTS: 'my_products',
  RESTAURANT_MENU: 'restaurant_menu',
  MEAL_PHOTO: 'meal_photo',
  MANUAL_ADD: 'manual_add',
};

// Track feature usage
export const trackUsage = async (feature, subFeature = null) => {
  try {
    const token = localStorage.getItem('gym_notebook_auth_token');
    if (!token) return; // Don't track if not logged in
    
    await api.post('/usage/track', {
      feature,
      sub_feature: subFeature
    });
  } catch (error) {
    // Silently fail - don't interrupt user experience
    console.debug('Usage tracking failed:', error);
  }
};

export default { trackUsage, FEATURES, NUTRITION_SUB_FEATURES };
